import { Injectable } from '@angular/core';
import { NgEntityService, NgEntityServiceConfig } from '@datorama/akita-ng-entity-service';

import { Review } from './review.model';
import { ReviewState, ReviewStore } from './review.store';

@Injectable()
@NgEntityServiceConfig({
  resourceName: 'reviews',
})
export class ReviewService extends NgEntityService<ReviewState> {
  constructor(protected store: ReviewStore) {
    super(store);
  }

  sendBulkReview(reviews: Review[]) {
    return this.getHttp().post(`${this.api}/bulk`, reviews);
  }
}
